// Client-side display-name policy — MUST mirror Server/src/utils/display_name_policy.py so people see why a name is refused before submitting.
import { z } from "zod";

export const PERSON_NAME_MAX_LENGTH = 50;
export const WORKSPACE_NAME_MAX_LENGTH = 100;

const MARKUP = /[<>]/;
// eslint-disable-next-line no-control-regex
const CONTROL_CHARS = /[\u0000-\u001f\u007f-\u009f\u202a-\u202e\u2066-\u2069]/;
const TLDS = "com|net|org|io|ai|app|dev|xyz|info|biz|ru|cn|link|click|top|site|online|ly|gl|tk|ml|ga|cf|gq|shop|live|store|page|sh|cc|ws";
const URL_PATTERN = new RegExp(`[a-z][a-z0-9+.-]*://|\\bwww\\.|\\b[a-z0-9-]+\\.(?:${TLDS})\\b`, "i");

// Returns the server's message for the first rule the name breaks, or null if it is acceptable
export function displayNameError(value: string, label: string, maxLength: number): string | null {
  if (CONTROL_CHARS.test(value)) return `${label} contains characters that aren't allowed`;
  const cleaned = value.trim().replace(/\s+/g, " ");
  if (!cleaned) return `${label} is required`;
  if (cleaned.length > maxLength) return `${label} must be ${maxLength} characters or fewer`;
  if (MARKUP.test(cleaned)) return `${label} can't contain < or >`;
  if (URL_PATTERN.test(cleaned)) return `${label} can't contain a link or web address`;
  return null;
}

// For zod's superRefine, so existing field rules (e.g. a minimum length) keep their own messages
export const personNameRefinement = (label: string) => (value: string, ctx: z.RefinementCtx) => {
  const error = displayNameError(value, label, PERSON_NAME_MAX_LENGTH);
  if (error) ctx.addIssue({ code: z.ZodIssueCode.custom, message: error });
};
